import config from "@/config/env";

// 导出一个函数，过滤掉对象中的字符串的前后空格
export function filterEmptyFields(obj) {
  const result = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      let value = obj[key];
      if (value !== null && value !== undefined) {
        if (typeof value === "string") {
          value = value.trim(); // 对字符串值进行trim处理
        }
        // 不再过滤掉为空的字段，包括trim后的空字符串、空对象和空数组
        result[key] = value;
      } else {
        // 即使是null或undefined，也保留字段
        result[key] = value;
      }
    }
  }
  return result;
}

export function findValueByIdAndKey(array, id, key, idKey = "id") {
  // 定义一个递归函数来处理查找逻辑
  function search(items) {
    for (let i = 0; i < items.length; i++) {
      // 检查当前项的id是否与给定id匹配
      if (items[i][idKey] == id) {
        // 如果匹配，返回对应键的值
        return items[i][key] || "";
      }
      // 如果当前项有children字段，递归搜索children
      if (items[i].children && items[i].children.length > 0) {
        const resultInChildren = search(items[i].children);
        // 如果在children中找到了结果，直接返回
        if (resultInChildren !== "") {
          return resultInChildren;
        }
      }
    }
    // 如果当前层级没有找到，返回''
    return "";
  }

  // 开始递归搜索
  return search(array);
}

// 判断当前时间是否超过投稿截止时间（截止日期配置在 config/env.js 的 submissionDeadline）
export function isSubmissionClosed() {
  const deadline = new Date(config.submissionDeadline?.replace(/-/g, "/"));
  return Date.now() > deadline.getTime();
}
